const UserActionTypes = {
    SET_CURRENT_USER : "SET_CURRENT_USER",
    FETCH_ALL_USERS_START: "FETCH_ALL_USERS_START",
    FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
    FETCH_ALL_USERS_FAILURE: "FETCH_ALL_USERS_FAILURE",
    CHANGE_USER_PASSWORD_START: "CHANGE_USER_PASSWORD_START",
    CHANGE_USER_PASSWORD_SUCCESS: "CHANGE_USER_PASSWORD_SUCCESS",
    CHANGE_USER_PASSWORD_FAILURE: "CHANGE_USER_PASSWORD_FAILURE",
    POST_ACCOUNT_ACTIVATION_START: "POST_ACCOUNT_ACTIVATION_START",
    POST_ACCOUNT_ACTIVATION_SUCCESS: "POST_ACCOUNT_ACTIVATION_SUCCESS",
    POST_ACCOUNT_ACTIVATION_FAILURE: "POST_ACCOUNT_ACTIVATION_FAILURE",
    HANDLE_USER_PIN_START: "HANDLE_USER_PIN_START",
    HANDLE_USER_PIN_SUCCESS: "HANDLE_USER_PIN_SUCCESS",
    HANDLE_USER_PIN_FAILURE: "HANDLE_USER_PIN_FAILURE",
    REGISTERATION_HIDDEN_START: 'REGISTERATION_HIDDEN_START',
    LOGIN_HIDDEN_START: 'LOGIN_HIDDEN_START',
    HEADER_DROPDOWN_START: 'HEADER_DROPDOWN_START',
    FETCH_IF_USER_ALREADY_EXISTS: 'FETCH_IF_USER_ALREADY_EXISTS',
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
    SIGN_IN_START: 'SIGN_IN_START',
    SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
    SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
    SIGN_OUT_START: 'SIGN_OUT_START',
    SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
    SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',
    SIGN_UP_START: 'SIGN_UP_START',
    SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
    SIGN_UP_FAILURE: 'SIGN_UP_FAILURE',
    CHECK_USER_SESSION: 'CHECK_USER_SESSION',
    RUN_USER_SESSION_CHECK: 'RUN_USER_SESSION_CHECK',
}
export default UserActionTypes;